import AccountCreatedIcon from '../../../icons/User.svg?react';
import PhoneConfirmationIcon from '../../../icons/onboarding/PhoneConfirmation.svg?react';
import ProfileCompletedIcon from '../../../icons/onboarding/ProfileCompleted.svg?react';
import SegmentationAnsweredIcon from '../../../icons/onboarding/SegmentationAnswered.svg?react';
import PermissionAskedIcon from '../../../icons/onboarding/PermissionAsked.svg?react';
import CongratulationPageIcon from '../../../icons/onboarding/CongratulationPage.svg?react';
import SegmentationLegacyUserIcon from '../../../icons/onboarding/SegmentationLegacyUser.svg?react';
import CarwashIcon from '../../../icons/Carwash.svg?react';
import UserAction from '../../../icons/UserAction.svg?react';
import Strategy from '../../../icons/Strategy.svg?react';
import Ticket from '../../../icons/Ticket.svg?react';
import Prohibit from '../../../icons/Prohibit.svg?react';
import type { OnboardingData } from '../../../stores/onboarding';

export const friendlyNames: Record<string, string> = {
    phone_confirmation_setup: 'Phone Confirmation',
    profile_setup: 'Profile Completed',
    account_setup: 'Account Created',
    user_segmentation_setup: 'Segmentation Answered',
    permissions_setup: 'Permission Asked',
    congratulations_setup: 'Congratulation Page',
    user_segmentation_survey: 'Segmentation Legacy User',
    age_verification: 'Age Verification',
};

export const onboardingStepOrder = [
    'account_setup',
    'profile_setup',
    'phone_confirmation_setup',
    'age_verification',
    'user_segmentation_setup',
    'permissions_setup',
    'congratulations_setup',
];

const onboardingStepOrderMap = new Map(
    onboardingStepOrder.map((stepName, index) => [stepName, index])
);

export const iconsMap: Record<
    string,
    React.FC<React.SVGProps<SVGSVGElement>>
> = {
    phone_confirmation_setup: PhoneConfirmationIcon,
    profile_setup: ProfileCompletedIcon,
    account_setup: AccountCreatedIcon,
    user_segmentation_setup: SegmentationAnsweredIcon,
    permissions_setup: PermissionAskedIcon,
    congratulations_setup: CongratulationPageIcon,
    user_segmentation_survey: SegmentationLegacyUserIcon,
    IN_PROGRESS: PhoneConfirmationIcon,
    COMPLETED: ProfileCompletedIcon,
    NOT_STARTED: SegmentationAnsweredIcon,
    Carwash: CarwashIcon,
    Other: UserAction,
    Coupons: Ticket,
    Games: Strategy,
    age_verification: Prohibit,
};

export const calculateDifference = (
    current: number,
    previous: number
): number => {
    if (previous === 0) {
        return current > 0 ? current * 100 : 0;
    }
    return ((current - previous) / previous) * 100;
};

export const sortOnboardingSteps = (
    steps: OnboardingData[]
): OnboardingData[] => {
    return steps
        .map((step, index) => ({ step, index }))
        .sort((a, b) => {
            const orderA = onboardingStepOrderMap.get(
                a.step.onboardingStepName
            );
            const orderB = onboardingStepOrderMap.get(
                b.step.onboardingStepName
            );
            const safeOrderA = orderA ?? Number.MAX_SAFE_INTEGER;
            const safeOrderB = orderB ?? Number.MAX_SAFE_INTEGER;

            if (safeOrderA !== safeOrderB) {
                return safeOrderA - safeOrderB;
            }

            return a.index - b.index;
        })
        .map(({ step }) => step);
};
